/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useContext, useState } from 'react';
import { CoreContext } from '../../../context/CoreContext';

import { UserProfileContent, UserProfile } from './styled';

import { withFocusable } from '@noriginmedia/react-spatial-navigation';

export default withFocusable({})(function SideUserButton({
  onPress,
  focused,
}: {
  onPress?: () => void;
  focused?: boolean;
}) {
  const { currentProfile } = useContext(CoreContext);

  return (
    <>
      <UserProfileContent onPress={onPress}>
        <UserProfile source={currentProfile?.image} focused={focused} />
      </UserProfileContent>
    </>
  );
});
